import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CenterAlignmentIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.10538C2 4.4949 2.50083 4 3.11864 4H44.8814C45.4992 4 46 4.4949 46 5.10538C46 5.71586 45.4992 6.21076 44.8814 6.21076H3.11864C2.50083 6.21076 2 5.71586 2 5.10538Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.5527C2 13.9422 2.50083 13.4473 3.11864 13.4473H44.8814C45.4992 13.4473 46 13.9422 46 14.5527C46 15.1632 45.4992 15.6581 44.8814 15.6581H3.11864C2.50083 15.6581 2 15.1632 2 14.5527Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 33.4473C2 32.8368 2.50083 32.3419 3.11864 32.3419H44.8814C45.4992 32.3419 46 32.8368 46 33.4473C46 34.0578 45.4992 34.5527 44.8814 34.5527H3.11864C2.50083 34.5527 2 34.0578 2 33.4473Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8434 42.8946C12.8434 42.2841 13.3442 41.7892 13.962 41.7892H34.038C34.6558 41.7892 35.1566 42.2841 35.1566 42.8946C35.1566 43.5051 34.6558 44 34.038 44H13.962C13.3442 44 12.8434 43.5051 12.8434 42.8946Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 24C2 23.3895 2.50083 22.8946 3.11864 22.8946H44.8814C45.4992 22.8946 46 23.3895 46 24C46 24.6105 45.4992 25.1054 44.8814 25.1054H3.11864C2.50083 25.1054 2 24.6105 2 24Z"
  }));
});
CenterAlignmentIcon.displayName = 'CenterAlignmentIcon';
CenterAlignmentIcon.defaultProps = {
  'aria-label': 'CenterAlignment'
};
export default CenterAlignmentIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CenterAlignmentIcon/index.js
// module id = 1801
// module chunks = 12